export default __webpack_public_path__ + "static/media/homestead.d423bdc6.png";